import $axios from '../services/api.js'
import cookie from 'vue-cookie'

const actions = {
    loginByGoogle({ commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.post(`api/login`, payload)
                .then((response) => {
                    let split = response.data.data
                    let token = split.split('|')
                    token = token[1]
                    cookie.set('token', token)
                    commit('SET_TOKEN', token, { root: true })
                    resolve(response.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

export default {
    namespaced: true,
    actions,
}